// extracted by mini-css-extract-plugin
export default {"JsxFlowBlock":"JsxFlowBlock1OivWBxwN-Zf"};